"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const action_1 = __importDefault(require("@powerednow/shared/constants/action"));
const entity_1 = require("@powerednow/complexData/entity");
let AppointmentTypeEntity = class AppointmentTypeEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], AppointmentTypeEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], AppointmentTypeEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], AppointmentTypeEntity.prototype, "name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], AppointmentTypeEntity.prototype, "description", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: 15 })
], AppointmentTypeEntity.prototype, "defaultDuration", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: 0 })
], AppointmentTypeEntity.prototype, "defaultDurationId", void 0);
__decorate([
    (0, entity_1.field)({ type: 'decimal', defaultValue: 0 })
], AppointmentTypeEntity.prototype, "price", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], AppointmentTypeEntity.prototype, "editable", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], AppointmentTypeEntity.prototype, "isExternal", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], AppointmentTypeEntity.prototype, "isInternal", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string',
        defaultValue: 'You can request an appointment in the morning or afternoon and we '
            + 'will endeavour to meet your requirements. We will get straight back to you to confirm the appointment '
            + 'time or discuss an alternative if this does not work for either party',
    })
], AppointmentTypeEntity.prototype, "messageBefore", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string',
        defaultValue: 'Thanks for your booking!',
    })
], AppointmentTypeEntity.prototype, "messageAfter", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], AppointmentTypeEntity.prototype, "canBeMorning", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], AppointmentTypeEntity.prototype, "canBeAfternoon", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], AppointmentTypeEntity.prototype, "canBeEvening", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isDeleted', serverOnly: true })
], AppointmentTypeEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], AppointmentTypeEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: action_1.default.ACTION_TYPES.ACTION_TYPE_APPOINTMENT })
], AppointmentTypeEntity.prototype, "type", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string',
        isJSON: true,
        defaultValue: {
            color: '#000',
            fill: '#fff',
            backgroundColor: '#fff',
        },
    })
], AppointmentTypeEntity.prototype, "style", void 0);
AppointmentTypeEntity = __decorate([
    entity_1.EntityDecorator
], AppointmentTypeEntity);
exports.default = AppointmentTypeEntity;
//# sourceMappingURL=../../../../src/models/appointmentType/entity.js.map